module.exports = __webpack_public_path__ + "img/library.fc55269e.svg";